/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";

function UserInfo({ name, phone, email, id, noGutter, editable, category, isCustomer }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const userType = isCustomer ? "Customer" : "Provider"

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={3}
      mb={noGutter ? 0 : 1}
      mt={2}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
          mb={2}
        >
          <MDTypography variant="button" textTransform="capitalize">
            {userType} Name:&nbsp;
            <MDTypography variant="button" fontWeight="medium" textTransform="capitalize">
              {name}
            </MDTypography>
          </MDTypography>
          <MDTypography variant="button" textTransform="capitalize">
            {userType} ID:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="button" fontWeight="medium">
              {id}
            </MDTypography>
          </MDTypography>
          {
            editable ?
              <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
                <MDBox mr={1}>
                  <MDButton variant="text" color="error">
                    <Icon>delete</Icon>&nbsp;delete
                  </MDButton>
                </MDBox>
                <MDButton variant="text" color={darkMode ? "white" : "dark"}>
                  <Icon>edit</Icon>&nbsp;edit
                </MDButton>
              </MDBox> :
              null
          }
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="button" color="text">
            Phone:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <MDTypography variant="button" fontWeight="medium" textTransform="capitalize">
              {phone}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="button" color="text">
            Email:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <MDTypography variant="button" fontWeight="medium">
              {email}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          {
            category && category != "" ?
              <MDTypography variant="button" color="text" >
                Category:&nbsp;
                <MDTypography variant="button" fontWeight="medium">
                  {category}
                </MDTypography>
              </MDTypography>

              :
              null
          }
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

UserInfo.defaultProps = {
  noGutter: false,
};

UserInfo.propTypes = {
  name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string,
  noGutter: PropTypes.bool,
};

export default UserInfo;
